var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatistic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H14.5C14.75 10 15 9.75 15 9.5V4.25C15 4 14.75 3.75 14.5 3.75H13C12.75 3.75 12.5 4 12.5 4.25V9.5C12.5 9.75 12.75 10 13 10ZM16.75 10H18.25C18.5 10 18.75 9.75 18.75 9.5V0.5C18.75 0.25 18.5 0 18.25 0H16.75C16.5 0 16.25 0.25 16.25 0.5V9.5C16.25 9.75 16.5 10 16.75 10ZM5.5 10H7C7.25 10 7.5 9.75 7.5 9.5V6.75C7.5 6.5 7.25 6.25 7 6.25H5.5C5.25 6.25 5 6.5 5 6.75V9.5C5 9.75 5.25 10 5.5 10ZM9.25 10H10.75C11 10 11.25 9.75 11.25 9.5V1.75C11.25 1.5 11 1.25 10.75 1.25H9.25C9 1.25 8.75 1.5 8.75 1.75V9.5C8.75 9.75 9 10 9.25 10ZM19.375 12.5H2.5V0.625C2.5 0.279687 2.22031 0 1.875 0H0.625C0.279687 0 0 0.279687 0 0.625V13.75C0 14.4402 0.559766 15 1.25 15H19.375C19.7203 15 20 14.7203 20 14.375V13.125C20 12.7797 19.7203 12.5 19.375 12.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.4efded5024f5222381e38b52594e43e0.svg";
export { ForwardRef as ReactComponent };